import { render, staticRenderFns } from "./merchant-bg.vue?vue&type=template&id=6fbe1e12&scoped=true&"
import script from "./merchant-bg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./merchant-bg.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./merchant-bg.vue?vue&type=style&index=0&id=6fbe1e12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe1e12",
  null
  
)

export default component.exports